import { Grid, Typography } from '@mui/material';
import React from 'react';
import CustomButton from '../../../common/ui/CustomButton';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../../common/constants/Routes';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
function RoleHeader() {
  const{t}=useTranslation()
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(APP_ROUTES.DASHBOARD);
  };
  return (
    <Grid
      display={'flex'}
      justifyContent={'space-between'}
      alignItems={'center'}
      className='donation-header'
    >
      <Typography fontSize={20} fontWeight={700}>
      {t('Manage_Roles')}
      </Typography>

      <CustomButton
        type='button'
        text={`${t('Add_New_Role')}`}
        startIcon={AddIcon}
        className=' px-10 py-5 my-20'
        color={'warning'}
        fontSize={14}
        onClick={() => {
          navigate(APP_ROUTES.ROLEFORM);
        }}
      />
    </Grid>
  );
}

export default RoleHeader;
